module.exports = __webpack_public_path__ + "static/img/10006 (3).f0ace57.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10006 (3).webp
// module id = C0k0
// module chunks = 14